import { render, staticRenderFns } from "./CusModal.vue?vue&type=template&id=753b4ffe&"
import script from "./CusModal.vue?vue&type=script&lang=js&"
export * from "./CusModal.vue?vue&type=script&lang=js&"
import style0 from "./CusModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports